import { monitoringStatisticsForStepInstallations } from '@/helpers';
import { DestinationPhasedRelease, IntegrationInstallationId, RolloutMonitoring } from '@/types';
import { Destination } from '@/types/destinations';
import { StepGraphStep } from '@/types/workflow';

export interface DestinationRolloutMonitoring {
    destination: Destination;
    stepInstallationIds?: IntegrationInstallationId[];
    monitoring: RolloutMonitoring;
}

export const destinationRolloutMonitoringsForGroup = (
    phasedGroupData: DestinationPhasedRelease[],
    rolloutMonitoringByDestStepConfigId: Record<string, RolloutMonitoring> | undefined,
    rolloutStepConfigs: Record<string, StepGraphStep>,
): DestinationRolloutMonitoring[] => {
    if (!rolloutMonitoringByDestStepConfigId) {
        return [];
    }

    return phasedGroupData.reduce<DestinationRolloutMonitoring[]>((destinationMonitorings, { destination }) => {
        const monitoring = rolloutMonitoringByDestStepConfigId[destination.stepConfigId];
        if (!monitoring) {
            return destinationMonitorings;
        }

        const rolloutStep = Object.values(rolloutStepConfigs).find((stepConfig) =>
            stepConfig.destinationStepConfigIds?.includes(destination.stepConfigId),
        );
        const stepInstallationIds = rolloutStep?.integrationInstallationIds;
        const filteredMonitoring = {
            ...monitoring,
            monitoringStatistics: monitoringStatisticsForStepInstallations(
                monitoring.monitoringStatistics ?? [],
                stepInstallationIds,
            ),
        };

        if (filteredMonitoring.monitoringStatistics.length > 0) {
            destinationMonitorings.push({
                destination,
                stepInstallationIds,
                monitoring: filteredMonitoring,
            });
        }

        return destinationMonitorings;
    }, []);
};
